import { GITHUB_URL, MARKETING_URL } from "../lib/env";

export function Footer() {
  return (
    <footer className="footer">
      <p>
        © {new Date().getFullYear()} TONado Cash contributors · MIT licence · Open-source research
        software.
      </p>
      <nav>
        <a href={MARKETING_URL}>About</a>
        <a href={`${MARKETING_URL}/#security`}>Security</a>
        <a href={`${MARKETING_URL}/#faq`}>FAQ</a>
        <a href={GITHUB_URL} target="_blank" rel="noopener">
          GitHub
        </a>
      </nav>
    </footer>
  );
}
